/** Política de caché TanStack Query para Market API (staleTime / gcTime). */
export const MARKET_QUERY_CACHE = {
  defaults: {
    staleTime: 30_000,
    gcTime: 10 * 60_000,
    retry: 1,
  },
  status: {
    staleTime: 15_000,
    gcTime: 5 * 60_000,
    refetchInterval: 30_000,
  },
  chain: {
    staleTime: 60_000,
    gcTime: 10 * 60_000,
  },
  pools: {
    /** Identidad en seed local; métricas (TVL, volumen) se refrescan en background. */
    staleTime: 10 * 60_000,
    gcTime: 60 * 60_000,
  },
  pairs: {
    staleTime: 60_000,
    gcTime: 15 * 60_000,
  },
  pairDetail: {
    staleTime: 15_000,
    gcTime: 5 * 60_000,
  },
  tokenProfile: {
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  },
  tokenCatalog: {
    staleTime: 10 * 60_000,
    gcTime: 60 * 60_000,
  },
  pairCatalog: {
    staleTime: 10 * 60_000,
    gcTime: 60 * 60_000,
  },
  walletPermissions: {
    staleTime: 2 * 60_000,
    gcTime: 15 * 60_000,
  },
  ohlcv: {
    staleTime: 30_000,
    gcTime: 15 * 60_000,
  },
  trades: {
    staleTime: 10_000,
    gcTime: 3 * 60_000,
  },
  depth: {
    staleTime: 10_000,
    gcTime: 3 * 60_000,
  },
  portfolio: {
    staleTime: 2 * 60_000,
    gcTime: 15 * 60_000,
  },
} as const

export type MarketQueryCacheKey = keyof typeof MARKET_QUERY_CACHE
